import "./styles.scss";

import { useTranslation } from "react-i18next";

import ModalNew from "components/ModalNew";
import SelectablePill from "components/SelectablePill";

import task_status_data from "libs/task_status_data.json";

const mainClass = "status-explanation";

const StatusExplanation = ({ isOpen, isAdmin, onClose }) => {
  const { t } = useTranslation();

  return (
    <ModalNew
      title={t("Task statuses")}
      description={t("How do statuses work, and which status should I choose?")}
      variant="wide"
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <div className={`${mainClass}__header`}>
          <h6>{t("Explanation")}</h6>
          <p>
            {t(
              "The Webinity system for managing website-related tasks allows you to track the progress of various tasks, from planning to final approval and completion. Each task goes through a defined cycle of statuses, which help monitor the stage of completion, facilitate communication between you and the Webinity team, and ensure efficient verification of completed work. The system enables smooth movement of tasks between statuses, making it easier to track progress and manage the project.",
            )}
          </p>
        </div>
        <div className={`${mainClass}__list`}>
          {task_status_data
            ?.filter((item) => (!isAdmin ? item?.key !== "canceled" : true))
            ?.map(({ value, label, color, description }) => (
              <div key={value} className={`${mainClass}__list__item`}>
                <div className={`${mainClass}__list__item-pill`}>
                  <SelectablePill
                    data={{
                      value: value,
                      label: t(label),
                      color: color,
                    }}
                  />
                </div>
                <div className={`${mainClass}__list__item-description`}>
                  <p>{t(description)}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </ModalNew>
  );
};

export default StatusExplanation;
